module.exports = __webpack_public_path__ + "img/wz-4-4.8ac98bbf.png";